/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cursorProp[_ngcontent-%COMP%]{cursor:pointer;padding-right:1px}"];
export { styles as styles };
